import React, { useEffect, useState } from 'react';
import { TextField } from '@gerdau/hefesto/TextField';
import { Container, ContainerTooltip } from './styles';
import InputMask from 'react-text-mask';
import { Tooltip } from '@gerdau/hefesto/Tooltip';
import { useDispatch } from 'react-redux';
import { sendTagging } from '../../store/ducks/tagging/actions';
import { getTaggingInformationScreen } from '../../utils/Tagging';
import { useLocation } from 'react-router-dom';
import { getTimeMask } from '../../utils/validateInputs';

interface RangeTimePickerProps {
  startTime?: string;
  endTime?: string;
  disabled?: boolean;
  setStartTime(startTime: string): void;
  setEndTime(endTime: string): void;
}

const RangeTimePicker: React.FC<RangeTimePickerProps> = ({
  disabled,
  startTime,
  endTime,
  setEndTime,
  setStartTime
}) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [error, setError] = useState<'danger' | undefined>(undefined);

  const { screenName, itemDescription } = getTaggingInformationScreen(
    pathname,
    true
  );

  useEffect(() => {
    const hourError =
      startTime && endTime && startTime > endTime ? 'danger' : undefined;

    if (hourError && error !== 'danger') {
      dispatch(
        sendTagging({
          screenName,
          itemName: 'error:hora_fim',
          itemDescription: `${itemDescription}_errorHoraFim`,
          event: 'error',
          nonInteraction: true
        })
      );
    }
    setError(hourError);
  }, [startTime, endTime]);

  return (
    <Container>
      <TextField
        label=""
        className="inputTime"
        name="startTime"
        disabled={disabled}
        children={
          <InputMask
            mask={getTimeMask(startTime)}
            disabled={disabled}
            placeholder={'00:00'}
            value={startTime ?? ''}
            onChange={(event) => {
              setStartTime(event.target.value);
            }}
          ></InputMask>
        }
      ></TextField>

      {'às'}
      <Tooltip
        placement="bottom"
        title="A hora fim não pode ser menor do que a hora de início"
      >
        <ContainerTooltip>
          <TextField
            label=""
            className="inputTime"
            name="endTime"
            disabled={disabled}
            variant={error}
            children={
              <InputMask
                mask={getTimeMask(endTime)}
                disabled={disabled}
                placeholder={'00:00'}
                value={endTime ?? ''}
                onChange={(event) => {
                  setEndTime(event.target.value);
                }}
              ></InputMask>
            }
          ></TextField>
        </ContainerTooltip>
      </Tooltip>
    </Container>
  );
};

export default RangeTimePicker;
